import { LoadingButton } from "@mui/lab";
import { Box, Stack, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SearchForm from "components/SearchForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFillingPersonThunk } from "store/reducers/accounts";
import { assignFillingPersonThunk } from "store/reducers/machine_func/machineAssignments";

const AssignFillingPersonDialog = ({ open, handleClose, machine_id }) => {
  const [search, setSearch] = React.useState("");
  const dispatch = useDispatch();
  const fillingPersons = useSelector((state) => state.accounts.fillingPersons);
  const { fillingPersonAssignmentLoading } = useSelector(
    (state) => state.vending
  );

  const machine = useSelector((state)=>state.vending.machines).find((item)=>item.id === machine_id)
  useEffect(() => {
    if(open){
      dispatch(getFillingPersonThunk());
    }
  }, [dispatch,open]);

  const assignFillingPerson = (filling_person) => {
    // console.log({filling_person})
    dispatch(assignFillingPersonThunk({ filling_person:filling_person, machine: machine_id}));
  };

  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Select delivery boys to add"
    >
      <Box paddingX={2}>
        <SearchForm
          hint="Search delivery boy"
          submitSearch={setSearch}
          sx={{ marginY: 2 }}
        />
      </Box>
      {fillingPersons.length > 0 ? (
        <>
          {fillingPersons
            .filter((item) => item.profile !== null)
            .map((fillingPerson) => (
              <Stack
                justifyContent="space-between"
                margin={2}
                direction="row"
                alignItems="center"
                key={fillingPerson.id}
              >
                <Typography variant="body1">
                  {fillingPerson.profile.first_name} {fillingPerson.profile.last_name}
                </Typography>
                {machine?.filling_persons?.find(
                  (item) => item.id === fillingPerson.profile.id
                ) ? (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={fillingPersonAssignmentLoading[fillingPerson.profile.id]}
                    disabled
                  >
                    Assigned
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    variant="outlined"
                    size="small"
                    loading={fillingPersonAssignmentLoading[fillingPerson.profile.id]}
                    onClick={() => assignFillingPerson(fillingPerson.profile)}
                  >
                    Assign
                  </LoadingButton>
                )}
              </Stack>
            ))}
        </>
      ) : (

        <Typography paddingX={2} textAlign="center"> No items </Typography>

      )}
    </CustomDialog>
  );
};

export default AssignFillingPersonDialog;
